var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51267 15.1694C5.8758 15.1694 4.30596 15.8197 3.14852 16.9771C1.99107 18.1345 1.34082 19.7044 1.34082 21.3412V22.1005C1.34082 22.9327 1.50474 23.7568 1.82321 24.5256C2.14168 25.2945 2.60847 25.9931 3.19694 26.5816C3.7854 27.17 4.484 27.6368 5.25286 27.9553C6.02172 28.2737 6.84578 28.4377 7.67799 28.4377V28.4377C8.5102 28.4377 9.33426 28.2737 10.1031 27.9553C10.872 27.6368 11.5706 27.17 12.159 26.5815C12.7475 25.9931 13.2143 25.2945 13.5328 24.5256C13.8512 23.7568 14.0152 22.9327 14.0152 22.1005V1.65625C14.5125 4.8536 16.1528 7.76199 18.6318 9.84175L19.3472 10.442C20.6016 11.4944 22.1866 12.0712 23.824 12.0712V12.0712",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.ae8c6a8f69f8aebb91c4b284442a690f.svg";
export { ForwardRef as ReactComponent };